class TokenService {
    getLocalRefreshToken() {
        return localStorage.getItem("refreshToken");
    }
    getLocalAccessToken() {
        return localStorage.getItem("accessToken");
    }
    getLocalMerchantID() {
        return localStorage.getItem('merchantID');
    }
    getLocalUserToken() {
        return localStorage.getItem("userToken");
    }
    getLocalAppToken() {
        return localStorage.getItem("appToken");
    }
    getLocalAppID() {
        return localStorage.getItem("appID");
    }
    getLocalMode() {
        let mode = localStorage.getItem("mode");
        if (mode === null) {
            mode = 'light';
            this.updateLocalMode(mode);
        }
        return mode;
    }
    updateLocalMode(mode) {
        localStorage.setItem('mode', mode);
    }
    updateLocalMerchantID(id) {
        localStorage.setItem('merchantID', id);
    }
    updateLocalAccessToken(accessToken) {
        localStorage.setItem("accessToken", accessToken);
    }
    updateLocalRefreshToken(refreshToken) {
        localStorage.setItem("refreshToken", refreshToken);
    }
    updateLocalUserToken(userToken) {
        localStorage.setItem("userToken", userToken);
    }
    updateLocalAppToken(appToken) {
        localStorage.setItem("appToken", appToken);
    }
    updateLocalAppID(appID) {
        localStorage.setItem("appID", appID);
    }
    removeAccessToken() {
        localStorage.removeItem("accessToken");
    }
    removeRefreshToken() {
        localStorage.removeItem("refreshToken");
    }
  }
  export default new TokenService();